export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc',
}
